import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Injectable()
export class SampleAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'Sample';

  public GetCompanies() {
    const request = 'getCompanies';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<any>>(url);
  }

  public GetDynamicSample() {
    const request = 'getDynamicSample';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<any>>(url);
  }
}
